module.exports = __webpack_public_path__ + "static/media/chat.01efa63c.gif";